<nz-input-number *ngIf="dataset[row] !== undefined && dataset[row][colData.Name] !== undefined" [disabled]="GetDisabledValue()"
    [nzFormatter]="formatterAmount" nzMin="0" [name]="colData.Name" [(ngModel)]="dataset[row][colData.Name]"
    [ngModelOptions]="{ updateOn: 'blur'}" (ngModelChange)="valueChanged($event);">
</nz-input-number>
